module.exports = __webpack_public_path__ + "static/media/e334cf3c-db00-4470-80b7-000e19003a6a.d67c6481.jpg";